export interface Survey {
  description: string;
  pages: SurveyPage[];
}

export interface SurveyPage {
  description: string;
  priority: number;
  questions: SurveyQuestion[];
}

export interface SurveyQuestion {
  id: string;
  text: string;
  display_type: SurveyDisplayType;
  possible_answers?: string[];
  required: boolean;
  priority: number;
}

export enum SurveyDisplayType {
  DROP_DOWN = 'single_select_dropdown',
  RADIO_HORIZONTAL = 'radio_horizontal',
  RADIO_VERTICAL = 'radio_vertical',
  CHECKBOX_VERTICAL = 'checkbox_vertical',
  CHECKBOX_HORIZONTAL = 'checkbox_horizontal'
}

export interface SurveyAnswers {
  answers: SurveyAnswer[];
}

export interface SurveyAnswer {
  id: string;
  text: string;
}
